import React, { useState } from "react";

export function AboutPage({ t }) {
  return (
    <div className="container"><div className="info-card">
      <h2 className="page-title">{t("about_title")}</h2>
      <div className="prose-body">
        <p>{t("about_p1")}</p>
        <h3>{t("about_h1")}</h3>
        <p>{t("about_p2")}</p>
        <h3>{t("about_h2")}</h3>
        <p>{t("about_p3")}</p>
        <h3>{t("about_h3")}</h3>
        <p>{t("about_p4")}</p>
      </div>
    </div></div>
  );
}

export function ContactPage({ t }) {
  const [sent, setSent] = useState(false);
  return (
    <div className="container"><div className="info-card" style={{ maxWidth:560 }}>
      <h2 className="page-title">{t("nav_contact")}</h2>
      {sent ? (
        <div style={{ textAlign:"center", padding:"32px 0" }}>
          <div style={{ fontSize:48, marginBottom:12 }}>✅</div>
          <div style={{ fontWeight:700, fontSize:18, marginBottom:8 }}>{t("msg_sent")}</div>
          <div style={{ color:"var(--text-muted)" }}>{t("msg_sent_sub")}</div>
        </div>
      ) : (
        <form onSubmit={e => { e.preventDefault(); setSent(true); }}>
          {[[t("name"),"text",t("full_name")],[t("email"),"email",t("email_placeholder")]].map(([l,ty,p])=>(
            <div key={l} className="form-group"><label className="field-label">{l}</label><input className="field" type={ty} placeholder={p} required /></div>
          ))}
          <div className="form-group"><label className="field-label">{t("subject")}</label>
            <select className="field">{[t("sub_1"),t("sub_2"),t("sub_3"),t("sub_4"),t("sub_5")].map(o=><option key={o}>{o}</option>)}</select>
          </div>
          <div className="form-group"><label className="field-label">{t("message")}</label>
            <textarea className="field" rows={5} placeholder={t("message_placeholder")} required style={{ resize:"vertical" }} />
          </div>
          <button type="submit" className="btn btn-primary">{t("send_message")}</button>
        </form>
      )}
      <div className="contact-info"><div>📧 taxverifypk@gmail.com</div><div>📍 {t("karachi_pakistan")}</div></div>
    </div></div>
  );
}

export function LegalPage({ title, children, t }) {
  return <div className="container"><div className="info-card"><h2 className="page-title">{title}</h2><div className="prose-body">{children}</div></div></div>;
}

export function PrivacyPage({ t }) {
  return <LegalPage title={t("nav_privacy")} t={t}>
    <p><em>Last updated: January 2026</em></p>
    <h3>Data Processing</h3><p>All receipt/bill images are processed entirely in your browser. No images or bill data are transmitted to our servers.</p>
    <h3>What We Collect</h3><p>We do not collect personally identifiable information unless you contact us.</p>
    <h3>Cookies</h3><p>Essential session cookies only. No advertising or tracking cookies.</p>
    <h3>Contact</h3><p>taxverifypk@gmail.com</p>
  </LegalPage>;
}

export function TermsPage({ t }) {
  return <LegalPage title={t("nav_terms")} t={t}>
    <p><em>Last updated: January 2026</em></p>
    <h3>Service</h3><p>TaxVerifypk.com provides NTN database lookup, QR detection, and direct links to official government portals. Results are informational only.</p>
    <h3>Limitations</h3><p>Data is sourced from FBR's published Active Taxpayer List and may not reflect real-time changes. Always verify through official government portals.</p>
    <h3>Prohibited Use</h3><p>Do not use this platform to defame businesses or make unsubstantiated legal claims.</p>
    <h3>Governing Law</h3><p>Laws of Pakistan. Disputes resolved in Karachi.</p>
  </LegalPage>;
}

export function DisclaimerPage({ t }) {
  return <LegalPage title={t("nav_disclaimer")} t={t}>
    <div style={{ background:"var(--sig-war-bg)", border:"1px solid var(--warn-border)", borderRadius:8, padding:"14px 18px", marginBottom:20, color:"var(--sig-war-txt)" }}>
      <strong>⚠️ This platform provides informational verification only. Always confirm with official FBR / provincial authorities. We are not affiliated with any government body.</strong>
    </div>
    <h3>Not Legal Advice</h3><p>Nothing here constitutes legal or tax advice.</p>
    <h3>Not Official Verification</h3><p>Data is sourced from FBR's published Active Taxpayer List. Always confirm via fbr.gov.pk for legal certainty.</p>
    <h3>Official Sources</h3><p>fbr.gov.pk · srb.gos.pk · pra.punjab.gov.pk · kpra.gov.pk · bra.gob.pk</p>
    <h3>No Liability</h3><p>All use is at your own risk.</p>
  </LegalPage>;
}
